import React from "react";
import { Navigate } from "react-router";
import { useSelector } from "react-redux";

import { useMainNav, useMainNavVisibility } from "../../helpers/mainNav";
import { resolveStaffHomePath } from "../../helpers/staffHome";
import { readStationChoice } from "../../helpers/stationChoice";

/** `/` and the logo. Admins land on the dashboard; scoped staff do not. */
export default function HomeRedirect() {
  const user = useSelector((state) => state?.currentUser?.user);
  const items = useMainNav();
  const visibility = useMainNavVisibility();
  return (
    <Navigate
      to={resolveStaffHomePath(user, items, visibility, {
        station: readStationChoice(),
      })}
      replace
    />
  );
}
